import { Module } from 'vuex';
import { getters } from './getters';
import { mutations } from './mutations';
import { createBulkJobActions } from './actions';
import { BulkJobState, RootState } from '../types';

export interface BulkJobModuleConfig {
	basePath: string;
	defaultSortBy: string;
}

/**
 * Build a namespaced Vuex module for a bulk-job feature. Each call returns a fresh state object so
 * the registered modules (enterprise menu pull, menu replication) keep isolated activeJob / polling
 * state — they only share the implementation, not the data.
 *
 * @param {BulkJobModuleConfig} config - REST base path + default history sort column for the feature
 * @return {Module<BulkJobState, RootState>}
 */
export function createBulkJobModule(config: BulkJobModuleConfig): Module<BulkJobState, RootState> {
	const defaultFilters: TableFilterParams = {
		page: 1,
		limit: 10,
		sortBy: config.defaultSortBy,
		sortDirection: 'desc'
	};
	return {
		namespaced: true,
		state: {
			activeJob: null,
			viewedJob: null,
			jobHistory: [],
			jobHistoryCount: 0,
			jobHistoryFilters: { ...defaultFilters },
			pollIntervalId: null
		},
		getters,
		actions: createBulkJobActions(config.basePath, defaultFilters),
		mutations
	};
}
